import { Button, Card, Typography } from "@material-tailwind/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AddLeaderProfile } from "../Dialog/AddLeaderProfile";
import { transform_skillLevel, transform_languages } from "../../components/Transformation/Transformations";

export default function TeacherProfileTable(props) {
  const { t } = useTranslation();
  const [teachingLanguage, setTeachingLanguage] = useState("");
  const [teachingLanguageSkill, setTeachingLanguageSkill] = useState("");
  const [changeIntroduction, setChangeIntroduction] = useState("");
  const [interestedTopic, setInterestedTopic] = useState("");
  const [creditAdjustmentRate, setCreditAdjustmentRate] = useState("");
  const [isChange, setIsChange] = useState("");
  const [addLeader, setAddLeader] = useState(false);

  const showEldStatus = props.affiliation && props.affiliation.trim() !== "";

  const TABLE_HEAD = [
    "No",
    t("become_a_leader.teaching_lang"),
    ...(showEldStatus ? ["Endorsement Status"] : []),
    "",
    t("become_a_leader.student_level_expected_by_teacher"),
    t("become_a_leader.course_intro"),
    t("become_a_leader.topics"),
    t("become_a_leader.rate")
  ];

  return (
    <>
      <Card className="h-[250px] w-full overflow-scroll bg-[var(--bg)]">
        <table className="w-full table-fixed text-center">
          <thead>
            <tr>
              {TABLE_HEAD.map((head, index) => {
                let widthClass = "";
                if (index === 0) {
                  widthClass = "w-12"; // No column - narrow
                } else if (index === 1) {
                  widthClass = "w-28"; // Teaching Language - medium
                } else if (showEldStatus && index === 2) {
                  widthClass = "w-20"; // ELD Status - narrow
                } else if ((showEldStatus && index === 3) || (!showEldStatus && index === 2)) {
                  widthClass = "w-40"; // Actions - wider
                } else if ((showEldStatus && index === 4) || (!showEldStatus && index === 3)) {
                  widthClass = "w-28"; // Teaching Language Level - medium
                } else if ((showEldStatus && index === 5) || (!showEldStatus && index === 4)) {
                  widthClass = "w-48"; // Course Introduction - wider
                } else if ((showEldStatus && index === 6) || (!showEldStatus && index === 5)) {
                  widthClass = "w-48"; // Topics - wider
                } else {
                  widthClass = "w-32"; // Rate - medium
                }
                return (
                  <th
                    key={head}
                    className={`border-b border-blue-gray-100 p-2 bg-[var(--bg)] ${widthClass}`}
                  >
                    <Typography
                      variant="small"
                      color="blue-gray"
                      className="font-normal leading-none opacity-70"
                    >
                      {head}
                    </Typography>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {props.TABLE_ROWS &&
              props.TABLE_ROWS?.results?.map(
                (
                  {
                    introduction,
                    teaching_language,
                    teaching_language_skill_level,
                    interested_topics,
                    credit_adjustment_rate,
                    is_active,
                    id,
                    eld_status
                  },
                  index
                ) => {
                  const isLast = index === props.TABLE_ROWS.length - 1;
                  const classes = isLast
                    ? "p-4"
                    : "p-4 border-b border-blue-gray-50";
                  return (
                    <tr key={id}>
                      <td className={`${classes} w-12`}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {index + 1}
                        </Typography>
                      </td>
                      <td className={`${classes} w-28`}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {t(transform_languages(teaching_language))}
                        </Typography>
                        {/* )} */}
                      </td>
                      {showEldStatus && (
                        <td className={`${classes} w-20`}>
                          <Typography
                            variant="small"
                            color="blue-gray"
                            className="font-normal"
                          >
                            {eld_status || "-"}
                          </Typography>
                        </td>
                      )}
                      <td className={`${classes} w-40`}>
                        <div className="flex justify-center flex-wrap gap-1">
                          <Button
                            color="amber"
                            size="sm"
                            className="text-xs px-2 py-1"
                            onClick={() => {
                              setAddLeader(true);
                              setIsChange(id);
                              setTeachingLanguage(teaching_language);
                              setTeachingLanguageSkill(
                                teaching_language_skill_level
                              );
                              setChangeIntroduction(introduction);
                              setInterestedTopic(interested_topics);
                              setCreditAdjustmentRate(credit_adjustment_rate);
                            }}
                          >
                            {t("generic.edit")}
                          </Button>
                          {is_active ? (
                            <Button 
                              color="red" 
                              size="sm"
                              className="text-xs px-2 py-1"
                              onClick={() => props.deactivate(id)}
                            >
                              {t("generic.deactivate")}
                            </Button>
                          ) : (
                            <Button 
                              color="purple" 
                              size="sm"
                              className="text-xs px-2 py-1"
                              onClick={() => props.activate(id)}
                            >
                              {t("generic.activate")}
                            </Button>
                          )}
                        </div>
                      </td>
                      <td className={`${classes} w-28`}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {t(transform_skillLevel(teaching_language_skill_level))}
                        </Typography>
                      </td>
                      <td className={`${classes} w-48`}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-center break-words"
                        >
                          {introduction}
                        </Typography>
                      </td>
                      <td className={`${classes} w-48`}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal text-center break-words"
                        >
                          {interested_topics}
                        </Typography>
                      </td>
                      <td className={`${classes} w-32`}>
                        <Typography
                          variant="small"
                          color="blue-gray"
                          className="font-normal"
                        >
                          {credit_adjustment_rate + " Lingo Credits"}
                        </Typography>
                      </td>
                    </tr>
                  );
                }
              )}
          </tbody>
        </table>
      </Card>
      <AddLeaderProfile
        open={addLeader}
        close={() => setAddLeader(false)}
        teaching_language={teachingLanguage}
        teaching_language_skill_level={teachingLanguageSkill}
        introduction={changeIntroduction}
        interested_topics={interestedTopic}
        creditAdjustmentRate={creditAdjustmentRate}
        index={isChange}
      />
    </>
  );
}
